/**
 * Typed search params for the `/payroll` route. The selected pay period lives in the URL so it is
 * deep-linkable AND compile-checked (the timesheets/estimates `searchParams` pattern). TanStack
 * Router validates the raw URL params through `validatePayrollSearch` on every navigation.
 *
 * `?week=YYYY-MM-DD` selects which pay period the computed-gross review grid reflects (the period
 * prev/next links carry this). The coarse endpoint (22-14) normalises any in-week date to the Monday
 * week-start; the SPA only carries the value.
 */

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export interface PayrollSearch {
  week?: string;
}

/** Coerce a raw URL value into an ISO date string, else undefined. */
function asIsoDate(value: unknown): string | undefined {
  return typeof value === 'string' && ISO_DATE.test(value) ? value : undefined;
}

/**
 * TanStack Router `validateSearch` for the payroll route. Keeps `week` only when it is a valid ISO
 * date so the canonical URL stays clean (`/payroll` vs `/payroll?week=2026-06-01`).
 */
export function validatePayrollSearch(raw: Record<string, unknown>): PayrollSearch {
  const search: PayrollSearch = {};
  const week = asIsoDate(raw.week);
  if (week) search.week = week;
  return search;
}
